import { render, staticRenderFns } from "./WechatCodeHelper.vue?vue&type=template&id=a1d2a84a"
import script from "./WechatCodeHelper.vue?vue&type=script&lang=js"
export * from "./WechatCodeHelper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/b08365e4-b55a-4269-82b4-b5e5a1490008/workspace/hsylc_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a1d2a84a')) {
      api.createRecord('a1d2a84a', component.options)
    } else {
      api.reload('a1d2a84a', component.options)
    }
    module.hot.accept("./WechatCodeHelper.vue?vue&type=template&id=a1d2a84a", function () {
      api.rerender('a1d2a84a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/common/WechatCodeHelper.vue"
export default component.exports